export type WorkListInDetailProps = {
  works: string[];
};

/**
 * 分析詳細ページ-作品リスト
 */
export default function WorkListInDetail({ works }: WorkListInDetailProps) {
  return (
    <ul className="flex flex-wrap gap-1.5">
      {works.map((work, index) => {
        if (!work.length) {
          return;
        }

        return (
          <li
            key={`${work}-${index}`}
            className="inline-flex items-center rounded border border-GRAY_3 bg-WHITE_2 px-2.5 py-0.5 text-sm text-GRAY_1"
          >
            {work}
          </li>
        );
      })}
    </ul>
  );
}
